<script>
    import NauiSwitch from "../../../../naui/atoms/NauiSwitch.svelte";
    import NauiCheckbox from "../../../../naui/atoms/NauiCheckbox.svelte";
    import NauiButton from "../../../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    let dispatch = createEventDispatcher();

     function submit(){
        dispatch('submit')
    }

    function prev(){
        dispatch('prev')
    }

</script>
<section>
    <fieldset>
        <legend>Daños a vehículo asegurado</legend>
        <div class="mb-1">
            <p>Descripción de daños a vehículo asegurado</p>
        </div>
        <textarea class="naui-input w-100 mb-2" style="min-height: 90px"
                  placeholder="Detalle los daños (máximo 200 caracteres)"></textarea>
        <div class="box-l sx-1 mb-2">
            <p class="min-w-300px">¿Requieres vehículo de reemplazo?</p>
            <NauiSwitch/>
        </div>
        <h3 style="font-size: 18px" class="secondary mb-1">Garantía en caso de ocurrencia de siniestro al vehículo</h3>
        <div class="back-gray p-1 radius max-w-900px mb-2">
            <p>*Tarjeta de crédito con cupo disponible de 1.30 SMMLV; este monto se utilizará como garantía de respaldo en caso de ocurrencia de siniestros al vehículo asignado (rayón, golpe, comparendo, etc.)</p>
        </div>
        <div class="box-l sx-1 mb-1">
            <p class="max-w-300px">¿Se causaron daños a tercero con el vehículo asegurado?</p>
            <NauiSwitch/>
        </div>
        <textarea class="naui-input w-100 mb-2" style="min-height: 90px"
                  placeholder="Detalle (máximo 200 caracteres)"></textarea>
        <div class="box-l sx-1 mb-1">
            <p class="min-w-300px">¿Hubo muertes y/o lesionados?</p>
            <NauiSwitch/>
        </div>
        <textarea class="naui-input w-100" style="min-height: 90px"
                  placeholder="Detalle (máximo 200 caracteres)"></textarea>
    </fieldset>
    <fieldset>
        <legend class="mb-ii">Aviso de siniestro</legend>
        <NauiCheckbox color="secondary" label="Declaro que los datos e información suministrados en la presente declaración son verídicos y que no se ha omitido ningún hecho o detalle importante relacionado con las preguntas anteriores. Nos comprometemos a colaborar con HDI Seguros S. A. En la mejor defensa de sus intereses. " />
        <div class="back-gray mt-2 p-1 radius max-w-600px mb-2">
            <p><strong>Atención:</strong> recuerde que al enviar el reporte su póliza será afectada. Por favor revise la información antes de enviar el reporte.</p>
        </div>
        <div class="box-l sx-1">
            <NauiButton caption="Regresar" mode="outline" color="accent" className="min-w-200px" on:click={prev}/>
            <NauiButton caption="Finalizar y enviar" mode="solid" color="accent" className="min-w-200px" on:click={submit}/>
        </div>
    </fieldset>
</section>